// export const domain = "https://demo.auroratradersnepal.com";
export const domain = "https://auroratradersnepal.com";
// export const domain = "http://localhost:3000";
